module.exports = __webpack_public_path__ + "media/frontend/base/typo/fonts/iconfont-web-and-print-5b4d9c83855729ee4d143fc374736390.woff";